import { TAGS_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import tagsTypes from '../../constants/tagsTypes'
import { axios } from '../../services'

// import { try_force_logoff } from '../auth'

const update_tag_request = () => {
  return {
    type: tagsTypes.update.request
  }
}

const update_tag_success = (response) => {
  return {
    type: tagsTypes.update.success,
    payload: response.data.tag
  }
}

const update_tag_failure = (messages) => {
  return {
    type: tagsTypes.update.failure,
    payload: messages
  }
}

const update_tag = (tag_id, values) => {
  return function (dispatch) {
    // Before Request
    dispatch(update_tag_request())

    // Request
    axios.patch(
      formatRoute(TAGS_ROUTES.update, {id: tag_id}),
      values
    ).then( response => {
      // success
      dispatch( update_tag_success(response) )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error updating tag."]
      }
      // dispatch( try_force_logoff(error.response) )
      dispatch( update_tag_failure(errors))
    })
  }

}

export {
  update_tag
}



// WEBPACK FOOTER //
// ./src/js/actions/tags/update.js